import { FC } from 'react'
import { AdditionalServicesDocuments } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesDocumentsPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesDocuments />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesDocumentsPage
